export default {
    menuData : [
        {
            name:"Home",
            url:"home"
        },
        {
            name:"Status",
            url:"status",
            twoMenu: [
                {
                    name:"WAN",
                    componentName:"wan",
                    icon:"img/nav_left/ic_status_wan_0.png",
                },
                {
                    name:"LAN",
                    componentName:"lan",
                    icon:"img/nav_left/ic_status_lan_0.png",
                },
                {
                    name:"Statistics",
                    componentName:"statistics",
                    icon:"img/nav_left/ic_status_statistics_0.png",
                },
                {
                    name:"WiFi Neighbor",
                    componentName:"wlanNeighbor",
                    icon:"img/nav_left/ic_wifi_tethering_0.png",
                }
            ]
        },
        {
            name:"Basic Setup",
            url:"basicSetup",
            twoMenu: [
                {
                    name:"LAN",
                    url:"",
                    icon:"img/nav_left/ic_basic_lan_0.png",
                    thrMenu:[
                        {name:"IPv4 Configuration",componentName:"lanIPv4"},
                        {name:"IPv6 Configuration",componentName:"lanIPv6"}
                    ]
                },
                {
                    name:"WLAN",
                    url:"",
                    icon:"img/nav_left/ic_basic_WLAN_0.png",
                    thrMenu:[
                        {name:"Basic Config 2.4GHz", componentName:"wl1Basic"},
                        {name:"Basic Config 5GHz", componentName:"wl0Basic"},
                        {name:"Security Setting 2.4GHz",componentName:"wl1Security"},
                        {name:"Security Setting 5GHz",componentName:"wl0Security"},
                        {name:"Advanced Config 2.4GHz",componentName:"wl1Advanced"},
                        {name:"Advanced Config 5GHz",componentName:"wl0Advanced"},
                        {name:"Mesh Info",componentName:"wlMeshInfo"},
                        {name:"Mesh Setting",componentName:"wlMeshConfig"},
                        {name:"Wi-Fi Repeater",componentName:"wlRepeate"}
                    ]
                },
                {
                    name:"NAT",
                    url:"",
                    icon:"img/nav_left/ic_basic_NAT_0.png",
                    thrMenu:[
                        { name: "Port Forwarding", componentName:"portForward"},
                        { name: "DMZ Host", componentName:"dmzHost"},
                        { name: "ALG", componentName:"alg"}
                    ]
                },
                {
                    name:"Security",
                    url:"",
                    icon:"img/nav_left/ic_basic_Security_0.png",
                    thrMenu:[
                        { name: "IP Filtering", componentName:"ipFilter"},
                        { name: "WLAN MAC Filtering", componentName:"macFilter"},
                        {name:"Dos Protection",componentName:"dosProtection"}
                    ]
                },
                {
                    name:"Routing",
                    componentName:"routing",
                    icon:"img/nav_left/ic_basic_Routing_1.png",
                }
            ]
        },
        {
            name:"Advance Setup",
            url:"advanceSetup",
            twoMenu:[
                {
                    name:"WAN Service",
                    componentName:"wanService",
                    icon:"img/nav_left/ico_advance_wan_0.png",
                },
                {
                    name:"Telnet Service",
                    componentName:"telnet",
                    icon:"img/nav_left/ic_advance_telnet_0.png",
                },
                {
                    name:"SSH Service",
                    componentName:"ssh",
                    icon:"img/nav_left/ic_advance_https_0.png",
                },
                {
                    name:"SNMP",
                    componentName:"snmp",
                    icon:"img/nav_left/ic_advance_device_hub_0.png",
                },
                {
                    name:"Service Ctrl",
                    componentName:"serveiceCtrl",
                    icon:"img/nav_left/ic_advance_games_0.png",
                },
                {
                    name:"CWMP",
                    componentName:"cwmp",
                    icon:"img/nav_left/ic_advance_devices_other_0.png",
                },
                {
                    name:"Mirror",
                    componentName:"mirror",
                    icon:"img/nav_left/ic_advance_airplay_0.png",
                },
                {
                    name:"Log",
                    componentName:"log",
                    icon:"img/nav_left/ic_advance_list_0.png",
                },
                {
                    name:"Quality of Service",
                    componentName:"qos",
                    icon:"img/nav_left/ic_advance_settings_applications_0.png",
                },
            ]
        },
        {
            name:"Application",
            url:"application",
            twoMenu:[
                {
                    name:"Storage Service",
                    url:"",
                    icon:"img/nav_left/ic_appli_device_0.png",
                    thrMenu:[
                        { name: "Device Info", componentName:"deviceInfo"},
                        { name: "User Accounts", componentName:"userAccounts"},
                        { name: "Share Folder", componentName:"shareFolder"},
                        { name: "Samba Server", componentName:"samba"},
                        { name: "FTP Server", componentName:"ftpServer"},
                        {name:"FTP Client",componentName:"ftpClient"},
                        { name: "TFTP Client", componentName:"tftpClient"},
                    ]
                },
                {
                    name:"DLNA",
                    componentName:"dlna",
                    icon:"img/nav_left/ic_appli_DLNA_0.png",
                },
                {
                    name:"DDNS",
                    componentName:"ddns",
                    icon:"img/nav_left/ic_appli_DDNS_0.png",
                },
                {
                    name:"UPnP",
                    componentName:"upnp",
                    icon:"img/nav_left/ic_appli_Multicast_0.png",
                },
                {
                    name:"Multicast",
                    componentName:"multicast",
                    icon:"img/nav_left/ic-manage-diagnosis-0.png",
                }
            ]
        },
        {
            name:"Management",
            url:"management",
            twoMenu:[
                {
                    name:"Settings",
                    url:"",
                    icon:"img/nav_left/ic-manage-setting-0.png",
                    thrMenu:[
                        {name:"Backup/Restore",componentName: "restore"},
                        { name: "Update Software", componentName: "update"},
                        { name: "Reset to Default", componentName:"resetDafult"}
                    ]
                },
                {
                    name:"Account Management",
                    componentName:"reloginpassword",
                    icon:"img/nav_left/ic-manage-accoun-0.png",
                },
                {
                    name:"NTP",
                    componentName:"ntp",
                    icon:"img/nav_left/ic_status_arp_0.png",
                },
                {
                    name:"Tools ",
                    url:"",
                    icon:"img/nav_left/ic-manage-diagnosis-0.png",
                    thrMenu:[
                        { name: "Ping Diagnosis", componentName:"ping"},
                        { name: "Trace Route Diagnosis", componentName:"traceRoute"},
                        { name: "Inform Manually", componentName:"tr069InformStatus"}
                    ]
                }
            ]
        }
    ]
}